//@flow

import React from 'react';
import AvatarHoverCardTruncatedText from 'app/common/react/components/AvatarHoverCard/AvatarHoverCardTruncatedText';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { Box } from 'gestalt';

const TITLE_HEIGHT_PIXELS = 18;

type Props = {|
  description: string,
  domainUrl: ?string,
  isHorizontalDesign: boolean,
  userFullName: string,
|};

export default function AvatarHoverCardContentText({
  description,
  domainUrl,
  isHorizontalDesign,
  userFullName,
}: Props) {
  const subtitle = description || domainUrl;
  const styles = {
    placeholder: {
      __style: {
        transition: 'opacity 200ms',
        opacity: !!subtitle ? 0 : 1,
      },
    },
    subtitle: {
      __style: {
        transition: 'opacity 200ms',
        opacity: !!subtitle ? 1 : 0,
      },
    },
  };

  return (
    <Box
      position="relative"
      width="100%"
      marginTop={isHorizontalDesign ? 4 : 3}
      marginBottom={3}
      alignItems={isHorizontalDesign ? 'start' : 'center'}
      display="flex"
      direction="column"
    >
      <Box height={TITLE_HEIGHT_PIXELS} width="100%">
        <Text
          align={isHorizontalDesign ? 'left' : 'center'}
          truncate
          size={isHorizontalDesign ? 'lg' : 'md'}
          weight={isHorizontalDesign ? 'bold' : 'semibold'}
        >
          {userFullName}
        </Text>
      </Box>
      <Box marginTop={2} overflow="hidden" position="relative" width="100%">
        <Box
          alignItems="center"
          dangerouslySetInlineStyle={styles.placeholder}
          direction="column"
          display="flex"
          height="100%"
          left
          position="absolute"
          top
          width="100%"
        >
          <Box color="lightGray" shape="pill" width={180} flex="grow" />
          <Box height={6} flex="none" />
          <Box color="lightGray" shape="pill" width={140} flex="grow" />
        </Box>
        {isHorizontalDesign &&
          !!domainUrl && (
            <Box
              dangerouslySetInlineStyle={styles.subtitle}
              width="100%"
              height="100%"
              marginTop={-1}
            >
              <AvatarHoverCardTruncatedText
                numLines={2}
                isBold
                isHorizontalDesign={isHorizontalDesign}
                singleLineMaxCharacters={36}
                text={domainUrl}
              />
            </Box>
          )}
        {isHorizontalDesign &&
          !!description && (
            <Box
              dangerouslySetInlineStyle={styles.subtitle}
              width="100%"
              height="100%"
              marginTop={2}
            >
              <AvatarHoverCardTruncatedText
                isHorizontalDesign={isHorizontalDesign}
                numLines={2}
                singleLineMaxCharacters={36}
                text={description}
              />
            </Box>
          )}
        {!isHorizontalDesign &&
          !!subtitle && (
            <Box dangerouslySetInlineStyle={styles.subtitle} width="100%" height="100%">
              <AvatarHoverCardTruncatedText
                isHorizontalDesign={isHorizontalDesign}
                numLines={2}
                singleLineMaxCharacters={27}
                text={subtitle}
              />
            </Box>
          )}
      </Box>
    </Box>
  );
}
